import { VOCategory } from "../model/DataStructure.js";

export class Breadcrumb {
    public element: HTMLDivElement;

    private _separatorCategory: HTMLSpanElement;
    private _labelCategory: HTMLSpanElement;
    private _separatorEntry: HTMLSpanElement;
    private _labelEntry: HTMLSpanElement;

    private _category: VOCategory = null;
    private _entry: string = null;

    constructor() {
        this.element = document.createElement("div");
        this.element.id = "breadcrumb";
        this.element.innerHTML = `
        <span id="breadcrumb-main">MOSAiC</span>
        <span class="separator category icon-124 hidden"></span>
        <span id="breadcrumb-category" class="hidden"></span>
        <span class="separator entry icon-124 hidden"></span>
        <span id="breadcrumb-entry" class="hidden"></span>
        `;

        this._separatorCategory = this.element.querySelector(".separator.category");
        this._labelCategory = this.element.querySelector("#breadcrumb-category");
        this._separatorEntry = this.element.querySelector(".separator.entry");
        this._labelEntry = this.element.querySelector("#breadcrumb-entry");
    }

    public get category(): VOCategory {
        return this._category;
    }

    public set category(category: VOCategory) {
        if (this._category === category)
            return;
        this._category = category;
        if (this._category) {
            this._labelCategory.textContent = this._category.title;
            this._labelCategory.classList.remove("hidden");
            this._separatorCategory.classList.remove("hidden");
        } else {
            this._labelCategory.classList.add("hidden");
            this._separatorCategory.classList.add("hidden");
        }
    }

    public get entry(): string {
        return this._entry;
    }

    public set entry(entry: string) {
        if (this._entry === entry)
            return;
        this._entry = entry;
        if (this._entry) {
            this._labelEntry.textContent = this._entry;
            this._labelEntry.classList.remove("hidden");
            this._separatorEntry.classList.remove("hidden");
        } else {
            this._labelEntry.classList.add("hidden");
            this._separatorEntry.classList.add("hidden");
        }
    }
}